// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingBar__container-f2dcaf {
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: transparent;
  z-index: 10;
}

.LoadingBar__progress-b9d6b4 {
  height: 100%;
  background-color: var(--brand-primary-40);
  transition: width 0.2s;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/LoadingBar/LoadingBar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background-color: transparent;\n  z-index: 10;\n}\n\n.progress {\n  height: 100%;\n  background-color: var(--brand-primary-40);\n  transition: width 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoadingBar__container-f2dcaf`,
	"progress": `LoadingBar__progress-b9d6b4`
};
module.exports = ___CSS_LOADER_EXPORT___;
